<template>
  <div>
    <template v-if="!isTag">
      <span>{{ name ? name.substring(0, name.length - 1) : '--' }}</span>
    </template>
    <template v-if="isTag" v-for="(item, index) in options">
      <template v-if="values.includes(item.value) ">
        <el-tag
          :disable-transitions="true"
          :key="item.value"
          :index="index"
          :type="item.raw.listClass == 'primary' ? '' : item.raw.listClass"
          :class="item.raw.cssClass"
        >
          {{ item.label}}
        </el-tag>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "DictTag",
  props: {
    options: {
      type: Array,
      default: null,
    },
    value: [Number, String, Array],
  },
  data(){
    return{
      name: '',
      isTag: false,
    }
  },
  computed: {
    values() {
      if (this.value !== null && typeof this.value !== 'undefined') {
        return Array.isArray(this.value) ? this.value : [String(this.value)];
      } else {
        return [];
      }
    },
  },
  watch:{
    value(){
      this.name = ''
      this.initName()
    }
  },
  created() {
    this.initName()
  },
  methods:{
    initName(){
      if(this.options && this.options.length > 0){
        if(this.options[0].raw.listClass == 'default' || this.options[0].raw.listClass == ''){
          this.isTag = false
        } else {
          this.isTag = true
        }
      }
      const that = this
      this.options.map(function (item){
        if(that.values.includes(item.value)){
          that.name += item.label + ';'
        }
      })
    }
  }
};
</script>
<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>
